import Connection from 'utils/connection';
import { GET_NOTIFICATIONS, MARK_NOTIFICATIONS_AS_READ } from 'constants/api';

const getNotifications = params => Connection.post(GET_NOTIFICATIONS, params);
const markNotificationsAsRead = params => Connection.post(MARK_NOTIFICATIONS_AS_READ, params);

export default { getNotifications, markNotificationsAsRead };
